module.exports = __webpack_public_path__ + "img/login-pic.970b9a86.svg";